import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { DatepickerTogglerComponent } from './datepicker-toggler.component';

@NgModule({
  declarations: [DatepickerTogglerComponent],
  exports: [DatepickerTogglerComponent],
  imports: [CommonModule, MatDatepickerModule, MatIconModule, MatInputModule, ReactiveFormsModule],
})
export class DatepickerCustomizationsModule {}
